
import { Component, Vue, Prop, Watch, Emit, Ref } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'
import MyCourse from './classroom/views/MyCourse/index.vue'
import MyStudy from './classroom/views/MyStudy/index.vue'
import MyAccount from './classroom/views/MyAccount/index.vue'
import MyCalendar from './classroom/views/MyCalendar/index.vue'
import Experience from './classroom/views/Experience/index.vue'
import Book from './classroom/views/Book/index.vue'
import HeaderUserPanel from './classroom/views/HeaderUserPanel/index.vue'
import ExpireBishanPop from './classroom/views/ExpireBishanPop/index.vue'
import StudyRecord from './classroom/views/StudyRecord/index.vue'
import CalendarMonthPop from './classroom/views/CalendarMonthPop/index.vue'
import UserContentPop from '@xt/www/components/classhour/pop-content/index.vue'
import type { HomeworkOption, DairyOption } from '@xt/client/entities/course-v2/user-content'
import type { MyLastReviewResponse } from '@xt/client/entities/my-v2/types'

@Observer
@Component({
  components: {
    MyCourse,
    MyStudy,
    MyAccount,
    MyCalendar,
    Experience,
    StudyRecord,
    Book,
    HeaderUserPanel,
    CalendarMonthPop,
    UserContentPop,
    ExpireBishanPop
  }
})
export default class MyClassroom extends Vue {
  @Ref()
  calendarMonthPop: {
    openPop: () => void
  }

  @Ref()
  userContentPop: {
    showPop: (options: HomeworkOption | DairyOption) => void
    hidePop: () => void
  }

  get UserStore() {
    return this.$store.$storeUser
  }

  get MyClassroomStore() {
    return this.$store.$myV2.Classroom
  }

  handleOpenUserContentPop(data: MyLastReviewResponse) {
    this.userContentPop.showPop({
      type: 'homework',
      homeworkId: data.id
    })
  }

  init(): void {
    this.MyClassroomStore.fetchUserPanelData()
    this.MyClassroomStore.fetchStudyRecordData(this.UserStore.UserInfo.id)
    this.MyClassroomStore.loadMyProductList()
    this.MyClassroomStore.loadMyStudyData()
  }

  created(): void {
    this.init()
  }

  handleOpenCalendarPop() {
    this.calendarMonthPop.openPop()
  }

  handleToSettings() {
    this.$router.push({
      path: `/myv2/settings`
    })
  }

  mounted(): void {}

  updated(): void {}

  destroyed(): void {
    this.MyClassroomStore.reset()
  }
}
